// frontend/src/utils/api.ts
// Utility for constructing API URLs that work in both development and production

/**
 * Get the base path for API calls.
 * In development: '' (empty, uses proxy to localhost:3001)
 * In production with PUBLIC_URL=/sim: '/sim'
 */
export const getBasePath = (): string => {
  // In development mode, don't use base path - rely on proxy
  if (process.env.NODE_ENV === 'development') {
    return '';
  }
  // PUBLIC_URL is set by Create React App from the "homepage" field in package.json
  const publicUrl = process.env.PUBLIC_URL || '';
  // Remove trailing slash if present
  return publicUrl.endsWith('/') ? publicUrl.slice(0, -1) : publicUrl;
};

/**
 * Construct a full API URL with the correct base path
 * @param path - The API path starting with /api/...
 */
export const apiUrl = (path: string): string => {
  const base = getBasePath();
  return `${base}${path}`;
};

/**
 * Construct a WebSocket URL with the correct base path
 * @param path - The WebSocket path (e.g., /api/ws)
 * @param params - Optional query parameters
 */
export const wsUrl = (path: string, params?: Record<string, string>): string => {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const host = window.location.host; // includes port if non-standard
  const base = getBasePath();
  const query = params ? '?' + new URLSearchParams(params).toString() : '';
  return `${protocol}//${host}${base}${path}${query}`;
};
